import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { MyTripsConfirmationNoComponent } from './mytrips-confirmation-no.component';

@NgModule({ declarations: [MyTripsConfirmationNoComponent],
    exports: [MyTripsConfirmationNoComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MyTripsConfirmationNosModule {}
